import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const CreateCategoryOfVacancyPage = () => (
  <TitleEntityForm
    create={apiRequests.hr.createCategory}
    backTo="/HR/categories"
    placeholder="Например, Разработка"
    createdText="Категория создана"
  />
);

export default CreateCategoryOfVacancyPage;
